/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_ExpiresInputs */



/**
* | output |
* | --- |
* | "Activation expires" |
*
* @param {License_ExpiresInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_expires = /** @type {((inputs?: License_ExpiresInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_ExpiresInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'activation expire le")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivierung läuft ab am")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'attivazione scade il")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Активация истекает")
	if (locale === "es") return /** @type {LocalizedString} */ ("La activación caduca el")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活到期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティベーションの有効期限")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्रियण समाप्त होगा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A ativação expira em")
	return /** @type {LocalizedString} */ ("Activation expires")
});